export const LIST_CLAIMS = 'LIST_CLAIMS';
export const MESSAGE = 'MESSAGE';
export const LIST_TYPE_PQR = 'LIST_TYPE_PQR';
export const SHOW_PQR = 'SHOW_PQR';
export const LIST_SUBJECT_PQR = 'LIST_SUBJECT_PQR';